import { IAction } from '@Root/types'

export const SubtitleActionTypes = {
  IMPORT_SRT: '@@subtitle/IMPORT_SRT',
  IMPORT_SRT_SUCCESS: '@@subtitle/IMPORT_SRT_SUCCESS',
  IMPORT_SRT_FAILURE: '@@subtitle/IMPORT_SRT_FAILURE',
  DELETE_LANGUAGE: '@@subtitle/DELETE_LANGUAGE',
  DELETE_LANGUAGE_SUCCESS: '@@subtitle/DELETE_LANGUAGE_SUCCESS',
  DELETE_LANGUAGE_FAILURE: '@@subtitle/DELETE_LANGUAGE_FAILURE',
}

export interface ISubtitleState {
  readonly importingSrt: boolean
}

export interface ISubtitle {
  readonly id: number
  readonly attributes: ISubtitleAttributes
}

export interface ISubtitleData {
  readonly id: string
  readonly type: 'subtitle'
  readonly attributes: ISubtitleAttributes
}

export interface ISubtitleAttributes {
  readonly type: string
  readonly stage: string
  readonly projectId: string
  readonly projectVersionId: string
  readonly language: string
  readonly category: string
  readonly createdAt: string
  readonly waitingForCompletionOfTranscript: boolean
  readonly transcription: boolean
  readonly hasPaidExportation: boolean
  readonly hasSpeakers: boolean
  readonly isExporting: boolean
  readonly exportedAt: string | null
  readonly exportationFileUrl: string | null
  readonly exportationUrls: IExportationUrls | null
  readonly hasVoice: boolean
  readonly numberOfVoiceSpeakers: number
  readonly belongsToTtsProject: boolean
  readonly percentageReviewed: number
  readonly canBeExported: boolean
  readonly canBeExportedAsSubtitles: boolean
  readonly countryFlag?: string
}

export interface ISubtitleReference {
  readonly id: string
  readonly type: 'subtitle'
}

export interface IExportationUrls {
  readonly [key: string]: string | undefined
}

export interface IImportSrtPayload {
  readonly projectVersionId: string
  readonly subtitleId: number
  readonly fileContent: string
  readonly enableSpeakerDiarization: boolean
}

export interface IDeleteLanguagePayload {
  readonly projectVersionId: string
  readonly subtitleId: number
}

export type IDeleteLanguageSuccessPayload = IDeleteLanguagePayload

export type TSubtitleActionTypes =
  IAction<IDeleteLanguageSuccessPayload>
